import { useDraggable } from '@dnd-kit/core'
import { nanoid } from 'nanoid'
import { useRef } from 'react'
import { fields } from './Fields'

export function SidebarField({ field: { title }, overlay }) {
  // Utilisation de template strings pour une concaténation plus propre
  const className = `sidebar-field${overlay ? ' overlay' : ''}`

  return <div className={className}>{title}</div>
}

function DraggableSidebarField({ field, ...rest }) {
  // Utilisation de la valeur de useRef directement pour éviter une variable supplémentaire
  const { current: id } = useRef(nanoid())

  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    data: {
      field,
      fromSidebar: true,
    },
  })

  return (
    <div
      ref={setNodeRef}
      className="sidebar-field"
      {...listeners}
      {...attributes}
    >
      <SidebarField field={field} {...rest} />
    </div>
  )
}

export default function Sidebar({ fieldsRegKey }) {
  return (
    <div key={fieldsRegKey} className="sidebar">
      {fields.map((f) => (
        // Utilisation du type comme clé uniquement si vous êtes sûr qu'il est unique dans votre array
        // Sinon, envisagez d'utiliser quelque chose comme f.id ou similaire.
        <DraggableSidebarField key={f.type} field={f} />
      ))}
    </div>
  )
}
